import { searchFormHelper } from './search-form';
import { abbreviate, formatMoney, formatter } from './util';
import { productGroupHelper } from './product-group';
import tippy from 'tippy.js';

/**
 * Shared features of products.
 */
var productHelper = (function ($) {
	/**
	 * Create product table rows from data.
	 *
	 * @param {{
	 *     items: {
	 *         id: string,
	 *         valid: boolean,
	 *         code: string,
	 *         name: string,
	 *         registeredName: string,
	 *         nameSupplement: string,
	 *         nameWithNameSupplement: string,
	 *         activeSubstance: string,
	 *         registrationNumber: string,
	 *         outageStatusDescription: string,
	 *         atcGroup: {
	 *             id: string,
	 *             code: string,
	 *             substance: string
	 *         },
	 *         vpoisCompany: {
	 *             id: string,
	 *             name: string
	 *         },
	 *         marketingAuthorizationHolder: {
	 *             id: string,
	 *             name: string
	 *             country: string
	 *         },
	 *         scauLastNotion: {
	 *             productId: string,
	 *             valid: boolean,
	 *             month: string,
	 *             cp: float,
	 *             uhr1: float,
	 *             ekv1: float,
	 *             juhr1: float,
	 *             odtd1: float,
	 *             odtdbal1: float,
	 *             uhr2: float,
	 *             ekv2: float,
	 *             juhr2: float,
	 *             odtd2: float,
	 *             odtdbal2: float,
	 *             uhr3: float,
	 *             ekv3: float,
	 *             juhr3: float,
	 *             odtd3: float,
	 *             odtdbal3: float,
	 *             vilpWithTempReimbursement: boolean,
	 *             referenceGroup: {
	 *                 id: string,
	 *                 code: string,
	 *                 name: string
	 *             }
	 *         },
	 *         scupLastNotion: {
	 *             productId: string,
	 *             valid: boolean,
	 *             month: string,
	 *             maxPriceExfactory
	 *         },
	 *         lastMonthDistributionPackagesTotal: int,
	 *         lastMonthDistributionPackagesTotalPercentageChange: int,
	 *         maxPriceExfactory: float,
	 *         uhr1: float,
	 *         ekv1: float,
	 *         invalidLastNotion: boolean,
	 *         scupActualLastNotion: boolean,
	 *         activeOrphan: boolean,
	 *         brotherResponses: [{
	 *             id: string,
	 *             valid: boolean,
	 *             code: string,
	 *             name: string,
	 *             registeredName: string,
	 *             nameSupplement: string,
	 *             nameWithNameSupplement: string,
	 *             activeSubstance: string,
	 *             registrationNumber: string,
	 *             outageStatusDescription: string,
	 *             atcGroup: {
	 *                 id: string,
	 *                 code: string,
	 *                 substance: string
	 *             },
	 *             vpoisCompany: {
	 *                 id: string,
	 *                 name: string
	 *             },
	 *             marketingAuthorizationHolder: {
	 *                 id: string,
	 *                 name: string
	 *                 country: string
	 *             },
	 *             scauLastNotion: {
	 *                 productId: string,
	 *                 valid: boolean,
	 *                 month: string,
	 *                 cp: float,
	 *                 uhr1: float,
	 *                 ekv1: float,
	 *                 juhr1: float,
	 *                 odtd1: float,
	 *                 odtdbal1: float,
	 *                 uhr2: float,
	 *                 ekv2: float,
	 *                 juhr2: float,
	 *                 odtd2: float,
	 *                 odtdbal2: float,
	 *                 uhr3: float,
	 *                 ekv3: float,
	 *                 juhr3: float,
	 *                 odtd3: float,
	 *                 odtdbal3: float,
	 *                 vilpWithTempReimbursement: boolean,
	 *                 referenceGroup: {
	 *                     id: string,
	 *                     code: string,
	 *                     name: string
	 *                 }
	 *             },
	 *             scupLastNotion: {
	 *                 productId: string,
	 *                 valid: boolean,
	 *                 month: string,
	 *                 maxPriceExfactory
	 *             },
	 *             lastMonthDistributionPackagesTotal: int,
	 *             lastMonthDistributionPackagesTotalPercentageChange: int,
	 *             maxPriceExfactory: float,
	 *             uhr1: float,
	 *             ekv1: float,
	 *             invalidLastNotion: boolean,
	 *             scupActualLastNotion: boolean
	 *         }],
	 *     }[],
	 *     pagination:{
	 *         total:int,
	 *         perPage:int,
	 *         currentPage:int,
	 *         totalPages:int,
	 *         _links:{}
	 *     }
	 * }} response Data returned from the server.
	 */
	var createProductTableRows = function (response) {
		$('.product-table .table').toggle(response.pagination.total > 0);
		$('.product-table .load-more').toggle(response.pagination.currentPage < response.pagination.totalPages);
		$('.product-table .no-results-container').toggle(response.pagination.total === 0);
		let withProductBrothers = $('#with-product-brothers').length > 0;

		for (var i = 0; i < response.items.length; i++) {
			createProductTableRow(response.items[i], false);

			if (withProductBrothers) {
				for (var j = 0; j < response.items[i].brotherResponses.length; j++) {
					createProductTableRow(response.items[i].brotherResponses[j], true);
				}
			}
		}
	};

	/**
	 * Create product table row.
	 *
	 * @param {{
	 *     id: string,
	 *     valid: boolean,
	 *     code: string,
	 *     name: string,
	 *     registeredName: string,
	 *     nameSupplement: string,
	 *     nameWithNameSupplement: string,
	 *     activeSubstance: string,
	 *     registrationNumber: string,
	 *     outageStatusDescription: string,
	 *     atcGroup: {
	 *         id: string,
	 *         code: string,
	 *         substance: string
	 *     },
	 *     vpoisCompany: {
	 *         id: string,
	 *         name: string
	 *     },
	 *     marketingAuthorizationHolder: {
	 *         id: string,
	 *         name: string,
	 *         country: string
	 *     },
	 *     scauLastNotion: {
	 *         productId: string,
	 *         valid: boolean,
	 *         month: string,
	 *         cp: float,
	 *         uhr1: float,
	 *         ekv1: float,
	 *         juhr1: float,
	 *         odtd1: float,
	 *         odtdbal1: float,
	 *         uhr2: float,
	 *         ekv2: float,
	 *         juhr2: float,
	 *         odtd2: float,
	 *         odtdbal2: float,
	 *         uhr3: float,
	 *         ekv3: float,
	 *         juhr3: float,
	 *         odtd3: float,
	 *         odtdbal3: float,
	 *         vilpWithTempReimbursement: boolean,
	 *         referenceGroup: {
	 *             id: string,
	 *             code: string,
	 *             name: string
	 *         }
	 *     },
	 *     scupLastNotion: {
	 *         productId: string,
	 *         valid: boolean,
	 *         month: string,
	 *         maxPriceExfactory
	 *     },
	 *     lastMonthDistributionPackagesTotal: int,
	 *     lastMonthDistributionPackagesTotalPercentageChange: int,
	 *     maxPriceExfactory: float,
	 *     uhr1: float,
	 *     ekv1: float,
	 *     invalidLastNotion: boolean,
	 *     scupActualLastNotion: boolean,
	 *     activeOrphan: boolean
	 * }} product Definition of the product.
	 */
	var createProductTableRow = function (product, isProductBrother) {
		var tableRow = $('<tr>');
		tippy('.tooltip');

		if (isProductBrother) {
			tableRow.addClass('table-clickable-row-brocode');
		}

		var detailUrl = location.pathname + '/' + encodeURIComponent(product.id) + location.search;
		var detailLink = $('<a class="btn-detail">').attr('href', detailUrl).text('detail');

		var scau = product.scauLastNotion;
		var warnings = '';

		if (product.invalidLastNotion) {
			tableRow.addClass('invalid-last-notion');
		}

		if (!product.valid) {
			warnings += '<span class="no-registration" title="Registrace tohoto produktu byla zrušena.">!</span>' + '\n';
			tableRow.addClass('invalid-registration');
		}

		if (scau !== null && scau.valid === false) {
			warnings +=
				'<span class="old-scau" title="Poslední data tohoto produktu jsou ze SCAU platného k ' +
				formatter.formatDate(scau.month) +
				'.">!</span>' +
				'\n';
		}

		if (scau !== null && (scau.ekv2 !== null || scau.juhr2 !== null || scau.odtdbal2 !== null)) {
			warnings += '<span class="multiple-uhr" title="Tento přípravek má více úhrad.">!</span>' + '\n';
		}

		if (product.scupActualLastNotion) {
			warnings += '<span class="scup-actual-last-notion" title="U tohoto přípravku vypisujeme SCUP.">!</span>' + '\n';
		}

		if (product.hasDncDou) {
			warnings += '<span class="dnc-dou" title="Tento přípravek má DNC/DoÚ.">!</span>' + '\n';
		}

		var atcGroup = $('<span>');
		if (product.atcGroup !== null) {
			atcGroup
				.append($('<span>').addClass('code').text(product.atcGroup.code))
				.append(' ')
				.append($('<span>').addClass('substance').text(abbreviate(product.atcGroup.substance, 16)));
		}

		var lastMonthDistributionPackagesTotalChange = '-';
		if (product.lastMonthDistributionPackagesTotalPercentageChange !== null) {
			if (product.lastMonthDistributionPackagesTotalPercentageChange > 0) {
				lastMonthDistributionPackagesTotalChange =
					'<span class="positive">+' + product.lastMonthDistributionPackagesTotalPercentageChange + ' %</span>';
			} else if (product.lastMonthDistributionPackagesTotalPercentageChange < 0) {
				lastMonthDistributionPackagesTotalChange =
					'<span class="negative">' + product.lastMonthDistributionPackagesTotalPercentageChange + ' %</span>';
			} else {
				lastMonthDistributionPackagesTotalChange = '<span class="same">0 %</span>';
			}
		}

		tableRow.append($('<td class="warnings">').html(warnings));
		let code = $('<td>').text(product.code);
		if (isProductBrother) {
			code.addClass('brocode');
			code.css({ 'font-size': '65%', color: '#777', 'padding-left': '14px' });
		}
		tableRow.append(code);
		let vilpLabelDiv =
			scau !== null && scau.vilpWithTempReimbursement
				? '<div style="background: rgb(147,197,253); color: #000; font-size: 9px; font-weight: 600; display: inline-block; text-decoration: none;" class="inline-block px-1 pt-0.5 pb-px ml-px rounded-sm font-roboto text-label font-bold text-black leading-none tracking-normal text-center bg-blue-300 align-top tooltip" data-tippy-content="Vysoce inovativní léčivý přípravek v dočasné úhradě">V</div>'
				: '';
		let activeOrphanLabelDiv = product.activeOrphan
			? '<div style="background: rgb(216,180,254); color: #000; font-size: 9px; font-weight: 600; display: inline-block; text-decoration: none;" class="inline-block px-1 pt-0.5 pb-px ml-px rounded-sm font-roboto text-label font-bold text-black leading-none tracking-normal text-center bg-purple-300 align-top tooltip" data-tippy-content="Léčivý přípravek na vzácná onemocnění s aktivním statusem orphan">O</div>'
			: '';
		tableRow.append(
			$('<td>').html(
				'<b><span>' +
					(product.registeredName || product.name) +
					'</span></b> <span>' +
					product.nameSupplement +
					'</span>' +
					' ' +
					vilpLabelDiv +
					' ' +
					activeOrphanLabelDiv
			)
		);
		tableRow.append($('<td class="atc-group">').html(atcGroup));
		tableRow.append(
			$('<td class="mah">').text(
				product.marketingAuthorizationHolder ? abbreviate(product.marketingAuthorizationHolder.name, 20) : '-'
			)
		);
		tableRow.append(
			$('<td>').text(
				product.scauLastNotion !== null && product.scauLastNotion.referenceGroup !== null
					? product.scauLastNotion.referenceGroup.code
					: '-'
			)
		);
		tableRow.append(
			$('<td class="number max-price-exfactory">').html(
				product.maxPriceExfactory ? formatMoney(product.maxPriceExfactory) : '-'
			)
		);
		tableRow.append($('<td class="number uhr1">').html(product.uhr1 ? formatMoney(product.uhr1) : '-'));
		tableRow.append($('<td class="number ekv1">').html(product.ekv1 ? formatMoney(product.ekv1, 4) : '-'));
		tableRow.append(
			$('<td class="number">').html(
				product.lastMonthDistributionPackagesTotal != null
					? formatMoney(product.lastMonthDistributionPackagesTotal, 0, ' ')
					: '-'
			)
		);
		tableRow.append($('<td class="number percent-change">').html(lastMonthDistributionPackagesTotalChange));
		tableRow.append($('<td>').text(product.outageStatusDescription));
		tableRow.append($('<td class="item-last">').html(detailLink));
		tableRow.clickableRow('btn-detail');

		$('.table tbody').append(tableRow);
	};

	var getProductsApiUrl = function () {
		var values = searchFormHelper.getSearchFormValues();
		var tfValues = searchFormHelper.getTFValues();
		var operator = searchFormHelper.getOperatorValue();
		var view = searchFormHelper.getViewValue();
		var queryString = '';

		for (var i = 0; i < values.length; i++) {
			queryString +=
				(i === 0 ? '?' : '&') + encodeURIComponent(values[i].name) + '=' + encodeURIComponent(values[i].value);
		}

		for (var i = 0; i < tfValues.length; i++) {
			queryString +=
				(values.length < 1 && i === 0 ? '?' : '&') +
				encodeURIComponent(tfValues[i].name) +
				'=' +
				encodeURIComponent(tfValues[i].value);
		}

		queryString += (queryString === '' ? '?' : '&') + 'operator=' + encodeURIComponent(operator);
		queryString += (queryString === '' ? '?' : '&') + 'view=' + encodeURIComponent(view);

		return '/products' + queryString;
	};

	return {
		createProductTableRows: createProductTableRows,
		getProductsApiUrl: getProductsApiUrl,
	};
})(jQuery);

/**
 * Features of product search.
 */
var productSearch = (function ($) {
	var root;

	var init = function () {
		root = $('.product-search');

		if (root.length === 0) {
			return;
		}

		root.find('.search-form-container').searchForm();
		root.find('.btn-create-product-group').createProductGroupModal('.create-product-group-modal');
		root.find('.table tbody tr').clickableRow('btn-detail');
		root
			.find('.product-table .btn-load-more')
			.loadMore(productHelper.getProductsApiUrl(), productHelper.createProductTableRows);

		$(document).on('productGroup.created', saveProductGroupFilters);
	};

	/**
	 * Save product group filters when product group has been created.
	 *
	 * @param {object} event Event data.
	 * @param {{
	 *     productGroup: {
	 *         id: string,
	 *         type: string,
	 *         name: string,
	 *         notification: {
	 *             settings: {
	 *                 frequency: string
	 *             }
	 *         },
	 *         productsCount:int
	 *     }
	 * }} response Data returned from the server.
	 */
	var saveProductGroupFilters = function (event, response) {
		productGroupHelper.createSaveFiltersApiRequest(response.productGroup.id).done(function () {
			productGroupHelper.redirectToProductGroupDetail(event, response);
		});
	};

	return {
		init: init,
	};
})(jQuery);

/**
 * Features of product detail.
 */
var productDetail = (function ($) {
	var init = function () {
		var root = $('.product-detail');

		if (root.length === 0) {
			return;
		}

		root.find('.detail-tabs a').tabs('.tab-content', 'item-act');
	};

	return {
		init: init,
	};
})(jQuery);

export { productHelper, productSearch, productDetail };
